export const JIRA_SETTING_REQUEST = 'JIRA_SETTING_REQUEST'
export const JIRA_SETTING_SUCCESS = 'JIRA_SETTING_SUCCESS'
export const JIRA_SETTING_ERROR = 'JIRA_SETTING_ERROR'
export const JIRA_SETTING_SET = 'JIRA_SETTING_SET'

export const JIRA_SETTING_CREATE_REQUEST = 'JIRA_SETTING_CREATE_REQUEST'

export const JIRA_SETTING_DELETE_REQUEST = 'JIRA_SETTING_DELETE_REQUEST'
export const JIRA_SETTING_DELETE_SUCCESS = 'JIRA_SETTING_DELETE_SUCCESS'
export const JIRA_SETTING_DELETE_ERROR = 'JIRA_SETTING_DELETE_ERROR'

export const JIRA_CONFIGURATION_REQUEST = 'JIRA_CONFIGURATION_REQUEST'
export const JIRA_CONFIGURATION_SUCCESS = 'JIRA_CONFIGURATION_SUCCESS'
export const JIRA_CONFIGURATION_ERROR = 'JIRA_CONFIGURATION_ERROR'
export const JIRA_CONFIGURATION_SET = 'JIRA_CONFIGURATION_SET'

export const JIRA_SETTING_UPDATE_REQUEST = 'JIRA_SETTING_UPDATE_REQUEST'
export const JIRA_SETTING_UPDATE_SUCCESS = 'JIRA_SETTING_UPDATE_SUCCESS'
export const JIRA_SETTING_UPDATE_ERROR = 'JIRA_SETTING_UPDATE_ERROR'

export const JIRA_CREATE_TICKET = 'JIRA_CREATE_TICKET'
export const JIRA_TICKET_FETCH_DETAILS = 'JIRA_TICKET_FETCH_DETAILS'
export const JIRA_TICKET_DETAILS_SET = 'JIRA_TICKET_DETAILS_SET'

export const JIRA_FETCH_TICKETS = 'JIRA_FETCH_TICKETS'
export const JIRA_FETCH_TICKETS_VALUES_SET = 'JIRA_FETCH_TICKETS_VALUES_SET'

export const JIRA_TICKET_STATUS_CHANGE = 'JIRA_TICKET_STATUS_CHANGE'

export const JIRA_ALL_TICKETS = 'JIRA_ALL_TICKETS'
export const JIRA_ALL_TICKETS_SET = 'JIRA_ALL_TICKETS_SET'

export const PROJECT_ID_SET = 'PROJECT_ID_SET'



// WEBPACK FOOTER //
// ./src/store/modules/jira/jira-setting.type.js